import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=f5e8191e&scoped=true"
import script from "./CardContent.vue?vue&type=script&lang=ts"
export * from "./CardContent.vue?vue&type=script&lang=ts"
import style0 from "./CardContent.vue?vue&type=style&index=0&id=f5e8191e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e8191e",
  null
  
)

export default component.exports